// This file is generated by running "yarn build".
// Manual changes will be lost.

import makeLogo from '../../make_logo';
import multiOnLight from '@veneer/assets/logos/multicolor/onLight/hP.03f9c77.svg';
import multiOnDark from '@veneer/assets/logos/multicolor/onDark/hP.d18665b.svg';
export var LogoHp = makeLogo('LogoHp', 'HP Logo', 36, 36, {
  multicolor: {
    onLight: multiOnLight,
    onDark: multiOnDark
  }
});